import { FC } from "react";
import { SanityInfoPage } from "../../graphql-types";
import { cn } from "../lib/helpers";
import FaqList from "./FaqList";
import * as styles from "./Tournaments.module.scss";
import { pageTitleStyle } from "./typography.module.scss";

export type TournamentsProps = Pick<
  SanityInfoPage,
  "tournamentsTitle" | "tournamentsFaq"
>;

const Tournaments: FC<TournamentsProps> = ({
  tournamentsTitle,
  tournamentsFaq,
}) => {
  return (
    <div className={styles.root}>
      <div className={cn(pageTitleStyle, styles.title)}>{tournamentsTitle}</div>
      <FaqList questionsAndAnswers={tournamentsFaq} color="orange" />
    </div>
  );
};

export default Tournaments;
